export const environment = {
  production: true,
  apiUrl: 'https://api-dev.estokai.com.br/api',
  keycloak: {
    url: 'https://iam-dev.estokai.com.br/auth',
    realm: 'estokai',
    clientId: 'web',
  },
};
